import React, { useEffect, useState } from 'react';
import { HomeHero } from '../components/HomeHero';
import { MovieCard } from '../components/MovieCard';
import { useI18n } from '../i18n/I18nContext';
import { getMovies } from '../services/api';
import { Movie, MoviesResponse } from '../types/api';

const emptyFilters = { languages: [], genres: [], countries: [] };

export const HomePage: React.FC = () => {
  const { locale, t } = useI18n();
  const [movies, setMovies] = useState<Movie[]>([]);
  const [filters, setFilters] = useState<MoviesResponse['filters']>(emptyFilters);
  const [query, setQuery] = useState({ search: '', language: '', genre: '', country: '' });
  const [loading, setLoading] = useState(true);
  const [searchOpen, setSearchOpen] = useState(false);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      const params = Object.fromEntries(Object.entries(query).filter(([, value]) => value));
      const response = await getMovies(params);
      setMovies(response.data);
      setFilters(response.filters);
      setLoading(false);
    };
    load().catch(() => setLoading(false));
  }, [locale, query]);

  return (
    <main>
      <HomeHero />

      <section className="mx-auto max-w-7xl px-4 py-8 pt-0 sm:px-6 lg:px-8">
        {/*<div className="flex justify-end">*/}
        {/*  <button*/}
        {/*    className="grid h-10 w-10 place-items-center rounded-md border border-stone-700 bg-black text-stone-200 shadow-sm transition hover:border-[#ffd460] hover:text-[#ffd460] focus:outline-none focus:ring-2 focus:ring-[#ffd460]/60"*/}
        {/*    onClick={() => setSearchOpen((current) => !current)}*/}
        {/*    type="button"*/}
        {/*    aria-expanded={searchOpen}*/}
        {/*    aria-label={searchOpen ? t('hideSearchFilters') : t('showSearchFilters')}*/}
        {/*    title={searchOpen ? t('hideSearchFilters') : t('showSearchFilters')}*/}
        {/*  >*/}
        {/*    <svg aria-hidden="true" className="h-5 w-5" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24">*/}
        {/*      <circle cx="11" cy="11" r="7" />*/}
        {/*      <path d="m21 21-4.3-4.3" />*/}
        {/*    </svg>*/}
        {/*  </button>*/}
        {/*</div>*/}
        {/*{searchOpen && (*/}
        {/*  <div className="mt-4 grid gap-3 rounded-lg border border-stone-800 bg-black p-4 shadow-sm md:grid-cols-4">*/}
        {/*    <input className="rounded-md border border-stone-700 bg-stone-950 px-3 py-2 text-white outline-none placeholder:text-stone-500 focus:border-[#ffd460] focus:ring-2 focus:ring-[#ffd460]/50" placeholder={t('searchPlaceholder')} value={query.search} onChange={(event) => setQuery((current) => ({ ...current, search: event.target.value }))} />*/}
        {/*    <select className="rounded-md border border-stone-700 bg-stone-950 px-3 py-2 text-white outline-none focus:border-[#ffd460] focus:ring-2 focus:ring-[#ffd460]/50" value={query.language} onChange={(event) => setQuery((current) => ({ ...current, language: event.target.value }))}>*/}
        {/*      <option value="">{t('allLanguages')}</option>*/}
        {/*      {filters.languages.map((value) => <option key={value}>{value}</option>)}*/}
        {/*    </select>*/}
        {/*    <select className="rounded-md border border-stone-700 bg-stone-950 px-3 py-2 text-white outline-none focus:border-[#ffd460] focus:ring-2 focus:ring-[#ffd460]/50" value={query.genre} onChange={(event) => setQuery((current) => ({ ...current, genre: event.target.value }))}>*/}
        {/*      <option value="">{t('allGenres')}</option>*/}
        {/*      {filters.genres.map((value) => <option key={value}>{value}</option>)}*/}
        {/*    </select>*/}
        {/*    <select className="rounded-md border border-stone-700 bg-stone-950 px-3 py-2 text-white outline-none focus:border-[#ffd460] focus:ring-2 focus:ring-[#ffd460]/50" value={query.country} onChange={(event) => setQuery((current) => ({ ...current, country: event.target.value }))}>*/}
        {/*      <option value="">{t('allCountries')}</option>*/}
        {/*      {filters.countries.map((value) => <option key={value}>{value}</option>)}*/}
        {/*    </select>*/}
        {/*  </div>*/}
        {/*)}*/}

        {loading ? (
          <p className="py-10 text-center text-stone-300">{t('loadingMovies')}</p>
        ) : (
          <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {movies.map((movie) => <MovieCard key={movie.id} movie={movie} />)}
          </div>
        )}
      </section>
    </main>
  );
};
